import {request} from '../jslib/request'

const BASE_REQUEST = '/tms/invoiceOcrSales'
export function list({pageNo,pageSize,invoiceTax,shipName,customerName,billNo }) {
  return request({
    url: `${BASE_REQUEST}/list`,
    method: 'get',
    data: {
      pageNo,pageSize,invoiceTax,shipName,customerName,billNo
    }
  })
}

export function ocrData({mode,invoicePic,relevantId }) {
  return request({
    url: `${BASE_REQUEST}/ocrData`,
    method: 'get',
    data: {
      mode,invoicePic,relevantId
    }
  })
}
export function splitInvoiceOcrRecord(data) {
  return request({
    url: `${BASE_REQUEST}/splitInvoiceOcrRecord`,
    method: 'post',
    data,
    json: true
  })
}
